// extracted by mini-css-extract-plugin
module.exports = {"individualDetail":"FarmDetailComponent_individualDetail__Hid9t","label":"FarmDetailComponent_label__3YLW8","value":"FarmDetailComponent_value__2oaiI"};